var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-confirmation"},[_c('input',{attrs:{"type":"checkbox"},on:{"change":_vm.doToggle}}),_c('label',{class:{ checked: _vm.value, 'm-confirmation__label': true },on:{"click":_vm.doToggle}},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }